module.exports = __webpack_public_path__ + "static/join-43e6b6b2ac3ed2d55f04cb39532cd00d.webp";